<template>
  <v-dialog :persistent="persistent" v-model="dialog" max-width="680px">
    <v-card>
      <v-card-title class="mx-3 d-flex justify-space-between">
        <span></span>
        <span>
          {{ $t("Distribution.logisticTrack.title") }}
        </span>
        <!-- <v-spacer></v-spacer> -->
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text
        v-if="!distribution.logistics_id"
        class="pa-8 text-center subtitle-1 red--text"
      >
        {{ $t("Distribution.logisticTrack.hint") }}
      </v-card-text>
      <v-card-text v-else>
        <v-row class="mt-4 text-h5 pl-3">
          {{ distribution.logistics_name }}{{ $t("Global.colon") }}
        </v-row>
        <v-row>
          <v-tabs
            v-model="tab"
            height="64"
            class="ms-3"
            background-color="transparent"
          >
            <v-tab v-for="value in tabs" :key="value">
              {{ value }}
            </v-tab>
          </v-tabs>
          <v-card-text class="py-3">
            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="(value, key) in logistics"
                :key="key"
                class="my-2"
              >
                <v-row v-for="(item, index) in value" :key="index">
                  <v-col
                    cols="12"
                    class="py-1 time--text subtitle-1 font-weight-bold"
                    >{{ item.AcceptTime }}</v-col
                  >
                  <v-col cols="12" class="py-1">{{ item.AcceptStation }}</v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

import Logistics from "@/api/logistics";

export default {
  name: "KdnLogisticAlert",

  props: {
    value: Boolean,
    title: String,
    persistent: Boolean,
    distribution: Object,
    distributionCode: String,
  },

  components: {},

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },
  mounted() {
    // this.getLogisticsFromAPI();
  },

  data: () => ({
    dialog: false,
    tab: null,
    logistics: null,
    tabs: [],
  }),

  methods: {
    getLogisticsFromAPI() {
      Logistics.trackByDistribution({
        distribution_code: this.distributionCode,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.logistics = response.data.logistics;
            this.tabs = Object.keys(this.logistics);
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) {
          this.$emit("close");
        } else {
          this.getLogisticsFromAPI();
        }
      },
    },
  },
};
</script>
